import axios from "axios";
import { Message, MessageBox } from "element-ui";
import store from "../store";
import { getToken } from "@/utils/auth";
import { clearCookie } from "./support";
import router from "../router";

const { hostname, protocol } = window.location;
const _url = protocol + "//" + hostname + ":8083/";
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API, // api的base_url
  baseUrl: _url,
  timeout: 0 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {
    // config.headers['token'] = getToken();
    // if (store.getters.token) {
    //    // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    config.headers.common = {
      "Content-Type": "application/json; charset=utf-8",
      token: getToken()
    };
    return config;
  },
  error => {
    // Do something with request error
    // console.log(error) // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res.code === 403) {
      Message({
        message: "登录过期或在别处登录!",
        type: "error",
        duration: 3 * 1000
      });
      clearCookie();
      router.push({ path: "/login" });
    } else {
      return res;
    }
  },
  error => {
    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 3 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;


export function downLoadExcel(url, params, name,type) {
  return new Promise((resolve, reject) => {
    // api
    // process.env.BASE_API
    axios
      .get(process.env.BASE_API+url, {
        params: params,
        responseType: "blob", // 1.首先设置responseType对象格式为 blob:
        headers: { token: getToken() }
      })
      .then(
        res => {
          if(res.status==200 &&res.config.responseType=='blob'){
            if(res.data.size==0||(res.headers['content-type']&&res.headers['content-type'].includes('json'))){
              let data=res.data
              let fileReader=new FileReader()
              fileReader.readAsText(data)
              fileReader.onload=function(result){
                let jsondata=JSON.parse(result.target.result)
                Message({
                  message: jsondata.msg,
                  type: "warning",
                  duration: 3 * 1000
                });
                return
              }
            }else{
              if(type=='zip'){
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  const blob = new Blob([res.data], { type: 'application/zip' })
                  window.navigator.msSaveOrOpenBlob(blob, name)
                } else {
                  /* 火狐谷歌的文件下载方式 */
                  const blob = new Blob([res.data], { type: 'application/zip' })
                  const url = window.URL.createObjectURL(blob)
                  const link = document.createElement('a') // 创建a标签
                  link.href = url
                  link.download = name // 文件重命名，若无需重命名，将该行删去
                  link.click()
                  URL.revokeObjectURL(url) // 释放内存
                }
                resolve(true)  
              }else{
                const blob2 = new Blob([res.data], { type: "application/excel" });
                const url2 = window.URL.createObjectURL(blob2);
                const link2 = document.createElement("a"); // 创建a标签
                link2.href = url2;
                link2.download = decodeURIComponent(name+'.xls');// 文件重命名，若无需重命名，将该行删去
                link2.click();
                URL.revokeObjectURL(url2);
              }
            }
          }
          resolve(true);
        },
        err => {
          Message({
            message: '导出错误',
            type: "error",
            duration: 3 * 1000
          });
          resolve(false);
        }
      )
      .catch(error => {
        reject(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js